import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.Ejhdi4',
    defaultMessage: 'Feedback',
  },
  description: {
    id: 'studio.yyC1Ex',
    defaultMessage: 'Let us know how we can improve Appsemble',
  },
});
